import {Button, Grid, List, ListItem, ListItemSecondaryAction, Typography} from "@material-ui/core";
import {ReactComponent as PremiumIcon} from '../../../../../../assets/images/icon-big-premium-88-px.svg';
import PropTypes from "prop-types";
import styles from "./PremiumDialogStyles";
import {listItems} from "./PremiumDialogHelper";
import PremiumNotification from "../../../../../ui/notifications/premium-notification/PremiumNotification";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";

const PremiumDialog = (props) => {
    const classes = styles();

    const dialogContent = (
        <Grid container className={classes.container}>
            <PremiumNotification icon={<PremiumIcon/>}
                                 title={"Assistenza Premium"}
                                 message={"Questo contratto prevede livello di assistenza PREMIUM con linea telefonica dedicata e SLA preferenziali"}/>
            <Grid item container justifyContent="space-around">
                <Grid item className={classes.leftBox} xs={10} sm={5}>
                    <Typography variant="h6">Tempi assistenza standard</Typography>
                    <List>
                        {listItems.map((item, idx) => (
                            <ListItem key={`assistenza-standard-list-item-${idx}`}>
                                <Typography variant="subtitle2" color="textSecondary">{item}</Typography>
                                <ListItemSecondaryAction>
                                    <Typography variant="subtitle1">8h</Typography>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item className={classes.rightBox} xs={10} sm={5}>
                    <Typography variant="h6">Tempi assistenza Premium</Typography>
                    <List>
                        {listItems.map((item, idx) => (
                            <ListItem key={`assistenza-premium-list-item-${idx}`}>
                                <Typography variant="subtitle2">{item}</Typography>
                                <ListItemSecondaryAction>
                                    <Typography variant="subtitle1">4h</Typography>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                        <ListItem>
                            <Typography variant="subtitle2">Con personale dedicati</Typography>
                        </ListItem>
                    </List>
                </Grid>
            </Grid>
        </Grid>
    );

    const dialogAction = (
        <Grid item container justifyContent="flex-end">
            <Button variant="text" color="secondary"
                    onClick={props.close}>indietro</Button>
        </Grid>
    );

    return (
        <GenericDialog
            dialogWidth={"md"}
            open={props.open}
            handleDialogClose={props.close}
            handleDialogCloseButton={props.close}
            dialogContent={dialogContent}
            dialogActions={dialogAction}
        >
            <Typography variant="h6">Richiedi assistenza</Typography>
        </GenericDialog>
    )
}

PremiumDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired
}

export default PremiumDialog;
